import { Outlet } from 'react-router-dom';

export const DeliveredServicesOutlet = () => <Outlet />;
